import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { patientBannerQuery } from '../api/patients.ts';
import { sessionQuery } from '../api/session.ts';
import { PatientDocumentsPanel } from './documents-panel.tsx';
import { documentPermissions } from './permissions.ts';

/**
 * Documents on the patient record (docs/plans/phase1-consultation.md §7.4): every visit's
 * sick sheets and referral letters, and uploads, which go to the patient's open visit.
 */
export function PatientRecordDocuments({ patientId }: { patientId: string }) {
  const { data: session } = useSuspenseQuery(sessionQuery);
  const banner = useQuery(patientBannerQuery(patientId));
  const open = banner.data?.openVisit ?? null;
  return (
    <PatientDocumentsPanel
      patientId={patientId}
      openVisitId={open?.id ?? null}
      may={documentPermissions(session)}
    />
  );
}
